import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
import _imports_0 from '../assets/images/logo.png';
const _hoisted_1 = { class: "log-reg register" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6" };
const _hoisted_5 = {
    id: "registerMod",
    class: "modal fade show",
    "aria-modal": "true",
    role: "dialog",
    style: { "display": "block" }
};
const _hoisted_6 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_7 = { class: "modal-content" };
const _hoisted_8 = { class: "modal-header justify-content-center" };
const _hoisted_9 = { class: "modal-body" };
const _hoisted_10 = { class: "form-area" };
const _hoisted_11 = { class: "tw-flex tw-justify-center tw-gap-8" };
const _hoisted_12 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_13 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_14 = { class: "tw-flex tw-justify-center tw-gap-8" };
const _hoisted_15 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_16 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_17 = { class: "tw-flex tw-justify-center tw-gap-8" };
const _hoisted_18 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_19 = {
    key: 0,
    class: "error_message"
};
const _hoisted_20 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_21 = {
    key: 0,
    class: "error_message"
};
const _hoisted_22 = { class: "tw-flex tw-justify-center tw-gap-8" };
const _hoisted_23 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_24 = {
    key: 0,
    class: "error_message"
};
const _hoisted_25 = { class: "input-area d-flex align-items-center tw-pr-0 tw-gap-2.5" };
const _hoisted_26 = {
    key: 0,
    class: "error_message"
};
const _hoisted_27 = {
    key: 0,
    class: "error_message text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_User = _resolveComponent("User");
    const _component_Earth = _resolveComponent("Earth");
    const _component_Phone = _resolveComponent("Phone");
    const _component_Lock = _resolveComponent("Lock");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close fa fa-times",
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("form", {
                                            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
                                            //@ts-ignore
                                            (...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
                                        }, [
                                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-text text-center tw-flex tw-justify-center tw-items-center tw-mt-4 tw-mb-10" }, [
                                                _createElementVNode("img", {
                                                    src: _imports_0,
                                                    class: "",
                                                    alt: "fav"
                                                })
                                            ], -1)),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createVNode(_component_User, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formData.firstname) = $event)),
                                                            type: "text",
                                                            placeholder: "first Name",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.firstname]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_User, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.lastname) = $event)),
                                                            type: "text",
                                                            placeholder: "last Name",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.lastname]
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_15, [
                                                        _createVNode(_component_Earth, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formData.country) = $event)),
                                                            type: "text",
                                                            placeholder: "Country",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.country]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _createVNode(_component_Phone, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.phone) = $event)),
                                                            type: "text",
                                                            placeholder: "Phone Number",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.phone]
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createVNode(_component_User, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formData.username) = $event)),
                                                            type: "text",
                                                            placeholder: "Username",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.username]
                                                        ])
                                                    ]),
                                                    (_ctx.errors.username)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.errors.username), 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createVNode(_component_User, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.email) = $event)),
                                                            type: "email",
                                                            placeholder: "Email",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.email]
                                                        ])
                                                    ]),
                                                    (_ctx.errors.email)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.errors.email), 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createVNode(_component_Lock, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.formData.password) = $event)),
                                                            type: "password",
                                                            placeholder: "Password",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.password]
                                                        ])
                                                    ]),
                                                    (_ctx.errors.password)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.errors.password), 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _createVNode(_component_Lock, { color: "#FFC827" }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.confirmPassword) = $event)),
                                                            type: "password",
                                                            placeholder: "Confirm Password",
                                                            autocomplete: "off"
                                                        }, null, 512), [
                                                            [_vModelText, _ctx.formData.confirmPassword]
                                                        ])
                                                    ]),
                                                    (_ctx.errors.confirmPassword)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.errors.confirmPassword), 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            (_ctx.backendError.message)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.backendError.message), 1))
                                                : _createCommentVNode("", true),
                                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "btn-area text-center" }, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "cmn-btn mt-4 !tw-w-full !tw-rounded-full !tw-px-6 !tw-py-[9px]"
                                                }, [
                                                    _createTextVNode(" Register "),
                                                    _createElementVNode("i", { class: "icon-d-right-arrow-2" })
                                                ])
                                            ], -1))
                                        ], 32)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
